/**
 * Auto-detect lesson type based on actual content files
 * Priority: video > audio > text
 */
export const getActualLessonType = (lesson: any): 'video' | 'audio' | 'text' => {
  // Check for video content first
  if (lesson.videoUrl || lesson.videoFile) {
    return 'video';
  }
  
  // Check for audio content
  if (lesson.audioUrl || lesson.audioFile) {
    return 'audio';
  }
  
  // Default to text
  return 'text';
};

/**
 * Check if lesson has video content
 */
export const hasVideo = (lesson: any): boolean => {
  return !!(lesson.videoUrl || lesson.videoFile);
};

/**
 * Check if lesson has audio content
 */
export const hasAudio = (lesson: any): boolean => {
  return !!(lesson.audioUrl || lesson.audioFile);
};

/**
 * Check if lesson has attachment
 */
export const hasAttachment = (lesson: any): boolean => {
  return !!(lesson.attachment || lesson.materials);
};

/**
 * Check if lesson has text content
 */
export const hasContent = (lesson: any): boolean => {
  return !!(lesson.content || lesson.description);
};
